module.exports = __webpack_public_path__ + "static/media/pierre.7b2a8dea.jpg";